import { ApexAccountOverview } from '../../../investment/components/account/ApexAccountOverview';

export default function ApexAccountOverviewPage() {
    return <ApexAccountOverview />;
}
